import { useState } from "react";
import { X, Save, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../api";

export default function ChangePasswordModal({ close }) {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) return toast.error("Yeni şifre en az 6 karakter olmalı");
    if (form.new_password !== form.confirm) return toast.error("Yeni şifreler eşleşmiyor");
    setSaving(true);
    try {
      await api.put("/auth/password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Şifreniz güncellendi");
      close();
    } catch (err) { toast.error(errMsg(err, "Şifre güncellenemedi")); }
    finally { setSaving(false); }
  };

  return (
    <div className="modal-backdrop" onClick={close}>
      <form className="modal" onClick={(e) => e.stopPropagation()} onSubmit={submit} data-testid="change-password-modal">
        <div className="modal-head">
          <div><span className="eyebrow">HESAP</span><h2><KeyRound size={16} style={{ verticalAlign: "-3px", marginRight: 6 }} />Şifre Değiştir</h2></div>
          <button type="button" onClick={close} data-testid="change-password-close"><X size={18} /></button>
        </div>
        <div className="form-grid">
          <label className="full-w">Mevcut Şifre
            <input type="password" required value={form.current_password} onChange={set("current_password")} data-testid="current-password-input" autoFocus />
          </label>
          <label>Yeni Şifre
            <input type="password" required value={form.new_password} onChange={set("new_password")} data-testid="new-password-input" />
          </label>
          <label>Yeni Şifre (Tekrar)
            <input type="password" required value={form.confirm} onChange={set("confirm")} data-testid="confirm-password-input" />
          </label>
        </div>
        <button type="submit" className="new-btn full" disabled={saving} data-testid="change-password-save"><Save size={15} /> {saving ? "Kaydediliyor…" : "Şifreyi Güncelle"}</button>
      </form>
    </div>
  );
}
